export default "__VITE_ASSET__a2hpfvVs__"